var React = require('react');

function IconGoogle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M248,8c-136.9,0 -248,111.1 -248,248c0,136.9 111.1,248 248,248c136.9,0 248,-111.1 248,-248c0,-136.9 -111.1,-248 -248,-248Zm-70.7,372c-68.8,0 -124,-55.5 -124,-124c0,-68.5 55.2,-124 124,-124c31.3,0 60.1,11 83,32.3l-33.6,32.6c-13.2,-12.9 -31.3,-19.1 -49.4,-19.1c-42.9,0 -77.2,35.5 -77.2,78.1c0,42.6 34.2,78.1 77.2,78.1c32.6,0 64.9,-19.1 70.1,-53.3l-70.1,0l0,-42.6l116.9,0c1.3,6.8 1.9,13.6 1.9,20.7c0,70.8 -47.5,121.2 -118.8,121.2Zm230.2,-106.2l0,35.5l-35.5,0l0,-35.5l-35.5,0l0,-35.5l35.5,0l0,-35.5l35.5,0l0,35.5l35.2,0l0,35.5l-35.2,0Z"}));
}

IconGoogle.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 496 512","version":"1.1"};

module.exports = IconGoogle;

IconGoogle.default = IconGoogle;
